//Timeout timer constant
export const TIMEOUT_TIMER_INTERVAL = 12 * 60; //Minutes Multiplied by 60 to convert in seconds
export const COUNTDOWN_TIME_TO_LOGOUT = 121; // In seconds
